export enum Generos {
  Masculino = 1,
  Femenino = 2
}
